<div class="pages">
  <div class="pages__content content">
    <div class="content__header">
      <button
        *ngIf="!showFullPage && pageInfoMode !== 'none'"
        tuiIconButton
        class="content__return-button"
        type="button"
        appearance="icon"
        iconStart="@tui.arrow-left"
        size="s"
        [tuiHint]="'common.buttons.return' | translate"
        (click)="onClickReturnButton()"
      ></button>

      <ng-container *ngIf="showFullPage">
        <h1 class="content__title">{{ 'components.pages.labels.pagesListTitle' | translate }}</h1>

        <button
          *ngIf="allowCreating$ | async"
          tuiIconButton
          class="button button_add"
          type="button"
          appearance="icon"
          iconStart="@tui.circle-plus"
          size="s"
          [tuiHint]="'common.buttons.create' | translate"
          (click)="onClickAddButton()"
        ></button>
      </ng-container>
    </div>

    <div [hide]="!showFullPage" class="content__list">
      <app-new-list
        [items]="pagesList$ | async"
        [itemContentTmp]="pageItemListTmp"
        [(selectedId)]="selectedPageId"
        (selectedIdChange)="onChangeSelectedPageId($event)"
      ></app-new-list>
    </div>

    <tui-scrollbar *ngIf="pageInfoMode !== 'none'" class="content__content">
      <app-page-info
        [(mode)]="pageInfoMode"
        [pageId]="selectedPageId"
        (saved)="reload()"
        (deleted)="onDeleted()"
      ></app-page-info>
    </tui-scrollbar>
  </div>
</div>

<ng-template #pageItemListTmp let-item>
  <app-pages-list-item [page]="item"></app-pages-list-item>
</ng-template>
